import Layout from "../components/layout"
import SEO from "../components/seo"
import HomeContact from "../components/HomeContact"
import React from "react"
import PageHero from "../components/PageHero"
import AC from "../images/ac-4.jpg"
import Button from "../components/Button"
import styled from "styled-components"
import Card from "../components/Card"
import Logo from "../images/logo.jpg"


const ContactContainer = styled.div`
  padding: 5vh 0 5vh 0;
  h4 {
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  }
`

const CouponContainer = styled.div`
border: 5px dashed #CE0101;
width: 100%;
padding: 0 3rem 2rem 3rem;
position: relative;
text-align: center;
@media only screen and (min-width: 1280px) {
  text-align: left;
}
  img {
    max-width: 150px;
    border-radius: 50%;
    display: block;
    margin: 1rem auto 1rem auto;
  }
  h2 {
  text-align: center;
  margin: 1rem 0 1.5rem 0;
  font-weight: 700;
  }
  
`


const CouponItem = styled.p`
  font-size: 1.5rem;
  color: #000;
  span {
    color: #0238AF;
    font-size: 1.5rem;
    font-weight: 700;
  }
`

const CouponDetails = styled.div`
  display: block;
  margin: 3rem auto 0 auto;
  
`
const CouponHeader = styled.h3`
font-family: Montserrat, sans-serif;
font-weight: 700;
text-align: center;
color: #CE0101;
`

const ButtonHolder = styled.div`
  text-align: center;
`


const ContactHeader = styled.h6`
font-family: Montserrat, sans-serif;
font-weight: 700;
text-align: center;
margin: 0 0 2rem 0;
`


const ContactPage = () => (
  <Layout>
    <SEO title="Contact" />


    <PageHero bg={AC} darkness={.3} h="50vh">
      <h2>Get in Touch</h2>
    </PageHero>

    <ContactContainer>
      <div className="container is-fluid">


        <div className="columns is-multiline">
          <div className="column is-two-thirds-widescreen is-12 is-flex">
            <CouponContainer>
              <img src={Logo} alt="Air Service Experts"/>
              <CouponHeader>NEW INSTALL SPECIAL</CouponHeader>
              <h2>$3,995</h2>
              <CouponDetails>

                <div className="columns is-multiline">
                  <div className="column is-6-desktop is-12">
                    <CouponItem><span>✓</span> Installation Included</CouponItem>
                  </div>
                  <div className="column is-6-desktop is-12">
                    <CouponItem><span>✓</span> Energy Saving Model</CouponItem>
                  </div>
                  <div className="column is-6-desktop is-12">
                    <CouponItem><span>✓</span> 10 year warranty!</CouponItem>
                  </div>
                  <div className="column is-6-desktop is-12">
                    <CouponItem><span>✓</span> 24 month financing</CouponItem>
                  </div>
                  <div className="column is-6-desktop is-12">
                    <CouponItem><span>✓</span> Best of all $0 down!</CouponItem>
                  </div>

                </div>

              </CouponDetails>

            </CouponContainer>

          </div>
          <div className="column is-one-third-widescreen is-12 is-flex">
            <Card m="0 0 0 0" p="2rem 1rem 1rem 1rem">
              <ContactHeader>Send Us a Message</ContactHeader>
              <form>
                <div className="field">
                  <label className="label">Your Name</label>
                  <div className="control">
                    <input className="input" type="text" placeholder="Your Name*" required/>
                  </div>
                </div>
                <div className="field">
                  <label className="label">Your Email</label>
                  <div className="control">
                    <input className="input" type="text" placeholder="Your Email" required/>
                  </div>
                </div>
                <div className="field">
                  <label className="label">Your Phone Number</label>
                  <div className="control">
                    <input className="input" type="text" placeholder="Your Phone Number*" required/>
                  </div>
                </div>
                <div className="field">
                  <label className="label">Your Message</label>
                  <div className="control">
                    <textarea className="textarea" placeholder="Your Message*" required/>
                  </div>
                </div>
                <Button m="3rem 0 0 0" p=".5rem 1.5rem .5rem 1.5rem">Submit</Button>
              </form>

            </Card>

          </div>
        </div>
      </div>
    </ContactContainer>


    <HomeContact/>


  </Layout>
)

export default ContactPage